import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from './translation.service';

@Pipe({
  name: 'translate',
})
export class TranslatePipe implements PipeTransform {
  constructor(private readonly translationService: TranslationService) {}

  transform(value: string, args?: any, languageCodeOverride?: string): any {
    if (!value) {
      return;
    }
    return this.translationService.translate(value, args, languageCodeOverride);
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [TranslatePipe],
  providers: [TranslatePipe],
  exports: [TranslatePipe],
})
export class TranslatePipeModule {}



// WEBPACK FOOTER //
// ./ts/app/shared/translate.pipe.ts